export default class MenuSticky extends HTMLElement {

    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.translations = this.getAttribute('translations');
        this.stickyContainer = this.getAttribute('sticky-container');
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#menu-sticky');
        this.instance = t.content.cloneNode(true);

        if (
            this.translations !== undefined &&
            this.stylesheet !== undefined
        ) {
            let translations = JSON.parse(this.translations);
            this._appendChild(this.instance);
            this._fillTranslations(translations);
            this._shadowRoot.appendChild(this.instance);


            let shadowRoot = this._shadowRoot;
            window.addEventListener('scroll', (event) => {
                let menuHeight = document.querySelector('.sticky-container').clientHeight;

                for (const translationsKey in translations) {
                    var stickyRect = document.querySelector('#' + `${translations[translationsKey].selector}`).getBoundingClientRect();
                    if ((stickyRect.top - menuHeight) <= menuHeight && (stickyRect.bottom - menuHeight) >= menuHeight) {
                        shadowRoot.getElementById(`${translations[translationsKey].id}`).classList.add(`active`);
                        shadowRoot.getElementById(`${translations[translationsKey].id}`).classList.remove(`inactive`);
                    } else {
                        shadowRoot.getElementById(`${translations[translationsKey].id}`).classList.add(`inactive`);
                        shadowRoot.getElementById(`${translations[translationsKey].id}`).classList.remove(`active`);
                    }
                }
            });

            this._shadowRoot.querySelector('[name="stylesheet"]').addEventListener('load', () => {
                this.style.display = "";
            });
            return shadowRoot;
        }
    }

    currentYPosition() {
        if (self.pageYOffset) return self.pageYOffset;
        if (document.documentElement && document.documentElement.scrollTop)
            return document.documentElement.scrollTop;
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
    }

    elmYPosition(eID) {
        var elm = document.getElementById(eID);
        if (!elm){
            return;
        }
        var y = elm.offsetTop;
        var node = elm;
        let menuHeight = document.querySelector(this.stickyContainer).clientHeight;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        }
        return y-menuHeight;
    }

    smoothScroll(eID) {
        var startY = this.currentYPosition();
        var stopY = this.elmYPosition(eID);

        var distance = stopY > startY ? stopY - startY : startY - stopY;

        if(distance == 0) {
            return;
        }

        if (distance < 100) {
            scrollTo(0, stopY);
            return;
        }
        var speed = Math.round(distance / 100);
        if (speed >= 150) speed = 150;
        var step = Math.round(distance / 25);
        var leapY = stopY > startY ? startY + step : startY - step;
        var timer = 0;
        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY += step;
                if (leapY > stopY) leapY = stopY;
                timer++;
            }
            return;
        }
        for (let i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step;
            if (leapY < stopY) leapY = stopY;
            timer++;
        }
        return false;
    }

    removeElement(element) {
        let elementContainer = this._shadowRoot.querySelector(element);
        if (elementContainer) {
            elementContainer.remove();
        }
    }

    _fillTranslations(translations) {
        const stickyTemplate = this.instance.querySelector('[name="sticky-group"]');
        for (const translationsKey in translations) {
            let stickyItem = document.createElement('a');
            stickyItem.setAttribute('link', '#' + `${translations[translationsKey].selector}`);
            stickyItem.setAttribute('id', `${translations[translationsKey].id}`);
            stickyItem.innerHTML = translations[translationsKey].value;
            if(translations[translationsKey].active) {
                stickyItem.classList.add('active');
            }
            else{
                stickyItem.classList.add('inactive');
            }
            if (translations[translationsKey].class) {
                stickyItem.classList.add(`${translations[translationsKey].class}`);
            }
            stickyTemplate.appendChild(stickyItem);

            stickyItem.addEventListener('click', (event) => {
                this.smoothScroll(`${translations[translationsKey].selector}`);
            });
        }
    }

    _appendChild(instance) {
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
    }
}
